import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { MultiLangCodes, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';
import { TSDViewGeneralInfoFormValues } from './validateTSDViewGeneralInfoForm';

interface TSDArrivalTransportMeansSectionProps {
  form: UseFormReturnType<TSDViewGeneralInfoFormValues>;
  disabled: boolean;
}

export const TSDArrivalTransportMeansSection: React.FC<TSDArrivalTransportMeansSectionProps> = ({ form, disabled }) => {
  const codelistSystems = useCodeListSystem({});

  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Arrival Transport Means
      </Title>

      <Grid>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('arrivalTransportMeans.identificationNumber')} label="Identification number" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={3}>
          <MultiLangCodes
            {...form.getInputProps('arrivalTransportMeans.typeOfIdentification')}
            label="Type of identification"
            system={codelistSystems}
            code="CL750"
            disabled={disabled}
          />
        </Grid.Col>

        <Grid.Col span={2}>
          <MultiLangCodes
            {...form.getInputProps('arrivalTransportMeans.nationality')}
            label="Nationality"
            system={codelistSystems}
            code="CL199"
            disabled={disabled}
          />
        </Grid.Col>

        <Grid.Col span={4}>
          <MultiLangCodes
            {...form.getInputProps('arrivalTransportMeans.modeOfTransportAtTheBorder')}
            label="Mode of transport at the border"
            code="CL710"
            system={codelistSystems}
            disabled={disabled}
          />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
